import React, { useCallback, useMemo } from "react";
import styled, { css } from "styled-components";
import Link from "next/link";

import { hexToRGBA } from "../../../utils/theme";
import Button from "../styled/Button";

const StyledErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-left: 20px;
  padding-right: 20px;

  .message-content {
    display: flex;
    justify-content: center;

    font-family: 'Arial';
    font-size: 18px;
    line-height: calc(1.4rem * (18 / 16));
    color: #C61F0C;
    text-align: center;

    ${({ showContactUsLink }) => showContactUsLink && css`
      color: ${hexToRGBA('#002346', 0.9)};
    `};
  }

  .action-block {
    margin-top: 32px;
  }
`;

function ErrorMessage({ showContactUsLink, showOK = { text: null, onClick: () => {} }, message = "Something went wrong", error }) {
  const messageContent = useMemo(() => {
    if (error && error.message.errors) {
      return error.message.errors[0];
    }

    if (error && !error.message.errors && error.message) {
      return error.message;
    }

    return message;
  }, [message, error]);

  const handleOK = useCallback(() => {
    showOK?.onClick && showOK.onClick();
  }, [showOK]);

  return (
    <StyledErrorMessage showContactUsLink={showContactUsLink}>
      <div className="message-content">
        {messageContent}
      </div>
      {showContactUsLink && (
        <div className="action-block">
          <Link href="/contactus" passHref>
            <Button>
              Contact Us
            </Button>
          </Link>
        </div>
      )}
      {showOK?.text && (
        <div className="action-block">
          <Button onClick={handleOK}>
            {showOK?.text}
          </Button>
        </div>
      )}
    </StyledErrorMessage>
  );
}

export default ErrorMessage;
